exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.the-map{-ms-flex:1;flex:1;margin-top:15px\n}\n.the-map .vue-map-container{height:330px;width:100%;position:sticky;top:30px\n}\n.the-map .scaled-down-arrow{transform:scale(0.5) translateX(8px)\n}\n.the-map a.gd{color:#19a7f3;cursor:pointer\n}\n.the-map a.gd:hover{text-decoration:underline\n}\n.gm-style-iw{max-width:200px\n}\n", ""]);

// exports
